var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("database-management", {
    attrs: {
      headings: _vm.headings,
      entries: _vm.entries,
      loading: _vm.loading,
      sort: _vm.sort,
      "sort-dir": _vm.sortDir,
    },
    on: {
      showModal: (id) => {
        _vm.selectedEntryId = id
        _vm.showModal()
      },
      updateSort: (key) => {
        _vm.updateSort(key)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "heading",
        fn: function () {
          return [_vm._v("Opportunity Management")]
        },
        proxy: true,
      },
      {
        key: "list",
        fn: function () {
          return _vm._l(_vm.sortedEntries, function (opportunity) {
            return _c("opportunity-management-list-item", {
              key: opportunity.id,
              attrs: { opportunity: opportunity },
              on: {
                edit: (id) => {
                  _vm.selectedEntryId = id
                  _vm.showModal()
                },
              },
            })
          })
        },
        proxy: true,
      },
      {
        key: "modal",
        fn: function () {
          return [
            _c("opportunity-management-modal", {
              ref: "modal",
              attrs: {
                opportunity:
                  _vm.selectedEntryIndex !== -1
                    ? _vm.entries[_vm.selectedEntryIndex]
                    : _vm.defaultEntry,
                categories: _vm.categories,
                offer: _vm.is_offer_enabled,
              },
              on: {
                create: (opportunity) => {
                  _vm.add(opportunity)
                },
                update: (opportunity) => {
                  _vm.update(opportunity)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }